// Famous Bhagavad Gita Shlokas — English & Hindi meanings
export const gitaShlokas = [
  {
    chapter: 2,
    shloka: 47,
    title: 'The Most Famous Shloka',
    sanskrit: 'कर्मण्येवाधिकारस्ते मा फलेषु कदाचन।\nमा कर्मफलहेतुर्भूर्मा ते सङ्गोऽस्त्वकर्मणि॥',
    english: 'You have the right to perform your prescribed duties, but you are not entitled to the fruits of your actions. Never consider yourself the cause of the results of your activities, and never be attached to not doing your duty.',
    hindi: 'तेरा कर्म करने में ही अधिकार है, फलों में कभी नहीं। तू कर्मफल का कारण मत बन और अकर्म में भी तेरी आसक्ति न हो।',
  },
  {
    chapter: 2,
    shloka: 20,
    title: 'The Immortal Soul',
    sanskrit: 'न जायते म्रियते वा कदाचिन्नायं भूत्वा भविता वा न भूयः।\nअजो नित्यः शाश्वतोऽयं पुराणो न हन्यते हन्यमाने शरीरे॥',
    english: 'The soul is never born nor dies at any time. It has not come into being, does not come into being, and will not come into being. It is unborn, eternal, ever-existing and primeval. It is not slain when the body is slain.',
    hindi: 'यह आत्मा न कभी जन्म लेती है, न मरती है। यह न पहले थी, न होगी, न होती है। यह अजन्मा, नित्य, शाश्वत और पुरातन है — शरीर के मारे जाने पर भी यह नहीं मारी जाती।',
  },
  {
    chapter: 2,
    shloka: 22,
    title: 'Changing Bodies',
    sanskrit: 'वासांसि जीर्णानि यथा विहाय नवानि गृह्णाति नरोऽपराणि।\nतथा शरीराणि विहाय जीर्णान्यन्यानि संयाति नवानि देही॥',
    english: 'As a person puts on new garments, giving up old and worn ones, similarly, the soul accepts new material bodies, giving up the old and useless ones.',
    hindi: 'जैसे मनुष्य पुराने वस्त्र उतारकर नए वस्त्र पहनता है, वैसे ही आत्मा पुराने शरीरों को छोड़कर नए शरीर धारण करती है।',
  },
  {
    chapter: 2,
    shloka: 23,
    title: 'The Indestructible Soul',
    sanskrit: 'नैनं छिन्दन्ति शस्त्राणि नैनं दहति पावकः।\nन चैनं क्लेदयन्त्यापो न शोषयति मारुतः॥',
    english: 'The soul can never be cut by any weapon, nor burned by fire, nor moistened by water, nor withered by the wind.',
    hindi: 'इस आत्मा को शस्त्र नहीं काट सकते, अग्नि नहीं जला सकती, जल नहीं भिगो सकता और वायु नहीं सुखा सकती।',
  },
  {
    chapter: 4,
    shloka: 7,
    title: 'The Purpose of Avatars',
    sanskrit: 'यदा यदा हि धर्मस्य ग्लानिर्भवति भारत।\nअभ्युत्थानमधर्मस्य तदात्मानं सृजाम्यहम्॥',
    english: 'Whenever and wherever there is a decline in righteousness, O descendant of Bharata, and a predominant rise of unrighteousness — at that time I manifest Myself.',
    hindi: 'हे भारत! जब-जब धर्म की हानि और अधर्म की वृद्धि होती है, तब-तब मैं स्वयं को प्रकट करता हूँ।',
  },
  {
    chapter: 4,
    shloka: 8,
    title: "God's Mission",
    sanskrit: 'परित्राणाय साधूनां विनाशाय च दुष्कृताम्।\nधर्मसंस्थापनार्थाय सम्भवामि युगे युगे॥',
    english: 'To deliver the pious and to annihilate the miscreants, as well as to reestablish the principles of dharma, I Myself appear millennium after millennium.',
    hindi: 'साधुओं की रक्षा करने के लिए, दुष्टों का विनाश करने के लिए और धर्म की स्थापना के लिए मैं युग-युग में अवतार लेता हूँ।',
  },
  {
    chapter: 3,
    shloka: 21,
    title: 'Leadership by Example',
    sanskrit: 'यद्यदाचरति श्रेष्ठस्तत्तदेवेतरो जनः।\nस यत्प्रमाणं कुरुते लोकस्तदनुवर्तते॥',
    english: 'Whatever action a great man performs, common people follow. And whatever standards he sets by his exemplary acts, all the world pursues.',
    hindi: 'श्रेष्ठ पुरुष जो-जो आचरण करता है, दूसरे लोग भी वैसा ही करते हैं। वह जो मानदण्ड स्थापित करता है, संसार उसी का अनुसरण करता है।',
  },
  {
    chapter: 6,
    shloka: 5,
    title: 'Be Your Own Friend',
    sanskrit: 'उद्धरेदात्मनात्मानं नात्मानमवसादयेत्।\nआत्मैव ह्यात्मनो बन्धुरात्मैव रिपुरात्मनः॥',
    english: 'One must deliver himself with the help of his mind, and not degrade himself. The mind is the friend of the conditioned soul, and his enemy as well.',
    hindi: 'अपने आप से अपना उद्धार करे, अपना पतन न करे। क्योंकि आत्मा ही अपना मित्र है और आत्मा ही अपना शत्रु है।',
  },
  {
    chapter: 7,
    shloka: 14,
    title: 'Crossing Maya',
    sanskrit: 'दैवी ह्येषा गुणमयी मम माया दुरत्यया।\nमामेव ये प्रपद्यन्ते मायामेतां तरन्ति ते॥',
    english: 'This divine energy of Mine, consisting of the three modes of material nature, is difficult to overcome. But those who have surrendered unto Me can easily cross beyond it.',
    hindi: 'मेरी यह त्रिगुणमयी दैवी माया को पार करना अत्यंत कठिन है। परन्तु जो मेरी शरण में आते हैं, वे इस माया को पार कर जाते हैं।',
  },
  {
    chapter: 9,
    shloka: 22,
    title: "God's Promise to Devotees",
    sanskrit: 'अनन्याश्चिन्तयन्तो मां ये जनाः पर्युपासते।\nतेषां नित्याभियुक्तानां योगक्षेमं वहाम्यहम्॥',
    english: 'But those who always worship Me with exclusive devotion, meditating on My transcendental form — to them I carry what they lack, and I preserve what they have.',
    hindi: 'जो अनन्य भाव से मेरा चिंतन करते हुए मेरी उपासना करते हैं, उन नित्ययुक्त भक्तों का योगक्षेम (जो नहीं है वो देना, जो है उसे बनाए रखना) मैं स्वयं वहन करता हूँ।',
  },
  {
    chapter: 11,
    shloka: 33,
    title: 'Time/Destiny',
    sanskrit: 'तस्मात्त्वमुत्तिष्ठ यशो लभस्व जित्वा शत्रून् भुङ्क्ष्व राज्यं समृद्धम्।\nमयैवैते निहताः पूर्वमेव निमित्तमात्रं भव सव्यसाचिन्॥',
    english: 'Therefore get up and prepare to fight and win glory. Conquer your enemies and enjoy a flourishing kingdom. They are already put to death by My arrangement, and you, O Savyasachin, can be but an instrument in the fight.',
    hindi: 'इसलिए उठो, यश प्राप्त करो, शत्रुओं को जीतकर समृद्ध राज्य भोगो। ये सब पहले ही मेरे द्वारा मारे जा चुके हैं। हे सव्यसाचिन! तू केवल निमित्त मात्र बन।',
  },
  {
    chapter: 18,
    shloka: 65,
    title: 'Greatest Promise',
    sanskrit: 'मन्मना भव मद्भक्तो मद्याजी मां नमस्कुरु।\nमामेवैष्यसि सत्यं ते प्रतिजाने प्रियोऽसि मे॥',
    english: 'Always think of Me, become My devotee, worship Me and offer your homage unto Me. Thus you will come to Me without fail. I promise you this because you are My very dear friend.',
    hindi: 'मुझमें मन लगा, मेरा भक्त बन, मेरी पूजा कर और मुझे नमस्कार कर। तू मुझे ही प्राप्त होगा — यह मेरा सत्य वचन है, क्योंकि तू मेरा प्रिय है।',
  },
  {
    chapter: 18,
    shloka: 66,
    title: 'The Final Teaching (Charamashloka)',
    sanskrit: 'सर्वधर्मान् परित्यज्य मामेकं शरणं व्रज।\nअहं त्वां सर्वपापेभ्यो मोक्षयिष्यामि मा शुचः॥',
    english: 'Abandon all varieties of religion and just surrender unto Me. I shall deliver you from all sinful reactions. Do not fear.',
    hindi: 'सभी धर्मों को छोड़कर केवल मेरी शरण में आ जा। मैं तुझे सभी पापों से मुक्त कर दूँगा। चिंता मत कर।',
  },
  {
    chapter: 18,
    shloka: 78,
    title: 'The Final Verse',
    sanskrit: 'यत्र योगेश्वरः कृष्णो यत्र पार्थो धनुर्धरः।\nतत्र श्रीर्विजयो भूतिर्ध्रुवा नीतिर्मतिर्मम॥',
    english: 'Wherever there is Krishna, the master of all mystics, and wherever there is Arjuna, the supreme archer, there will also certainly be opulence, victory, extraordinary power, and morality. That is my opinion.',
    hindi: 'जहाँ योगेश्वर श्रीकृष्ण हैं और जहाँ धनुर्धर अर्जुन हैं, वहीं श्री (समृद्धि), विजय, विभूति और अचल नीति है — यह मेरा मत है।',
  },
];
